module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0090.jpg?v=1a29f029";